module.exports = __webpack_public_path__ + "media/project/no-domains-199fd4c8.png";